const INITIAL_STATE = {
    orderGroup: {},
    orderGroups: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
    }
};

export default function orderGroupReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SELECT_GROUP':
            return {
                ...state,
                orderGroup: action.orderGroup,
            };
        case 'GROUPS_LIST':
            return {
                ...state,
                orderGroups: action.orderGroups,
            };
        case 'RESET':
            return {
                ...state,
                orderGroup: INITIAL_STATE.orderGroups,
                orderGroups: INITIAL_STATE.orderGroups
            };
        default:
            return state;
    }
}
